export const REPLACE_DATA = 'replaceData';
export const REJECT_OPTION_VALUE = 'reject';
export const DOCUMENT_ACCEPTED_TYPES = ['.xlsx'];
export const SAVE_PDF_ATTACHMENT_FAILED_MESSAGE =
  'Your file has not been saved. Attachments may not contain fillable or signature fields. Flatten the PDF and upload again.';
